import $ from 'jquery'
import { Fancybox } from "@fancyapps/ui";

$('.wp-block-image a').attr('data-fancybox','product-gallery')

Fancybox.bind('[data-fancybox]', {
    Thumbs: false,
});

$('.product-gallery-thumbnails a').click(function(){
    $('.product-gallery-thumbnails a.active').removeClass('active')
    $(this).addClass('active');

    let index = $(this).index();

    $('.product-gallery a').hide();
    $('.product-gallery a').eq(index).show();
    return false;
})


// WEBPACK FOOTER //
// ./resources/assets/js/partials/product.js